import { ShippingFormData } from '@/lib/types/operations/checkout'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface PendingAddress extends ShippingFormData {
  savedAt: string
}

export interface PendingDataState {
  pendingAddresses: PendingAddress[]
}

const initialState: PendingDataState = {
  pendingAddresses: []
}

const pendingDataSlice = createSlice({
  name: 'pendingData',
  initialState,
  reducers: {
    // Add address to the pending queue
    queuePendingAddress: (state, action: PayloadAction<PendingAddress>) => {
      // Check if we already have a similar address to avoid duplicates
      const exists = state.pendingAddresses.some(addr =>
        addr.address === action.payload.address &&
        addr.city === action.payload.city &&
        addr.zipCode === action.payload.zipCode
      )

      if (!exists) {
        state.pendingAddresses.push(action.payload)
      }
    },

    // Remove address from the queue (used after processing)
    removePendingAddress: (state, action: PayloadAction<PendingAddress>) => {
      state.pendingAddresses = state.pendingAddresses.filter(addr =>
        !(addr.address === action.payload.address &&
          addr.city === action.payload.city &&
          addr.zipCode === action.payload.zipCode)
      )
    },

    // Clear all pending addresses
    clearPendingAddresses: (state) => {
      state.pendingAddresses = []
    }
  }
})

export const {
  queuePendingAddress,
  removePendingAddress,
  clearPendingAddresses
} = pendingDataSlice.actions

export default pendingDataSlice.reducer
